'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.Avatar = undefined;

var _templateObject = _taggedTemplateLiteral(['\n\t\twidth: ', ';\n\t\theight: ', ';\n\n\t\t> .label {\n\t\t\tfont-size: ', ';\n\t\t}\n\t'], ['\n\t\twidth: ', ';\n\t\theight: ', ';\n\n\t\t> .label {\n\t\t\tfont-size: ', ';\n\t\t}\n\t']),
    _templateObject2 = _taggedTemplateLiteral(['\n\t\tcursor: pointer;\n\n\t\t&:hover {\n\t\t\tbackground-color: ', ';\n\t\t}\n\t'], ['\n\t\tcursor: pointer;\n\n\t\t&:hover {\n\t\t\tbackground-color: ', ';\n\t\t}\n\t']),
    _templateObject3 = _taggedTemplateLiteral(['\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: center;\n\tborder-radius: 50%;\n\tcolor: #fff;\n\tbackground-color: ', ';\n\n\t> .label {\n\t\tcolor: #fff;\n\t\tbackground-color: transparent;\n\t}\n\n\t> img {\n\t\tborder-radius: 50%;\n\t\theight: 100%;\n\t}\n\n\t', '\n\t', '\n'], ['\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: center;\n\tborder-radius: 50%;\n\tcolor: #fff;\n\tbackground-color: ', ';\n\n\t> .label {\n\t\tcolor: #fff;\n\t\tbackground-color: transparent;\n\t}\n\n\t> img {\n\t\tborder-radius: 50%;\n\t\theight: 100%;\n\t}\n\n\t', '\n\t', '\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _polished = require('polished');

var _globals = require('../globals');

var _globals2 = _interopRequireDefault(_globals);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var getAvatarColor = function getAvatarColor(color, id) {
	if (color) {
		return color;
	} else if (id) {
		var colors = [_globals2.default.colors.danger, _globals2.default.colors.violet, _globals2.default.colors.purple, _globals2.default.colors.navy, _globals2.default.colors.primary, _globals2.default.colors.teal, _globals2.default.colors.green, _globals2.default.colors.orange, _globals2.default.colors.orangeRed];

		return colors[id.charCodeAt(id.length - 1) % 9];
	} else {
		return _globals2.default.colors.primary;
	}
};

var avatarSizeMixin = function avatarSizeMixin(_ref) {
	var sm = _ref.sm,
	    md = _ref.md,
	    lg = _ref.lg;

	var size = '';
	var fontSize = '';

	switch (true) {
		case sm:
			size = '30px';
			fontSize = '13px';
			break;
		case md:
			size = '36px';
			fontSize = '15px';
			break;
		case lg:
			size = '42px';
			fontSize = '16px';
			break;
		default:
			size = '36px';
			fontSize = '15px';
			break;
	}

	return (0, _styledComponents.css)(_templateObject, size, size, fontSize);
};

var avatarClickableMixin = function avatarClickableMixin(_ref2) {
	var onClick = _ref2.onClick,
	    id = _ref2.id,
	    color = _ref2.color;

	if (!onClick) return '';

	var bgColor = (0, _polished.darken)(0.05, getAvatarColor(color, id));

	return (0, _styledComponents.css)(_templateObject2, bgColor);
};

var StyledAvatar = _styledComponents2.default.div(_templateObject3, function (props) {
	return getAvatarColor(props.color, props.id);
}, function (props) {
	return avatarSizeMixin(props);
}, function (props) {
	return avatarClickableMixin(props);
});

var Avatar = function Avatar(props) {
	var renderLabel = function renderLabel() {
		var user = props.user,
		    img = props.img,
		    children = props.children;


		if (img) {
			return _react2.default.createElement('img', { src: img });
		} else if (user) {
			var label = '';
			// eslint-disable-next-line
			var phoneReg = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;

			if (user.includes('@')) {
				label = '@';
			} else if (phoneReg.test(user)) {
				label = '#';
			} else {
				label = user.split(' ');
				if (label.length < 2) {
					label = label[0].charAt(0).toUpperCase();
				} else {
					label = label[0].charAt(0).toUpperCase() + label[1].charAt(0).toUpperCase();
				}
			}

			return _react2.default.createElement(
				'span',
				{ className: 'label' },
				label
			);
		} else if (children) {
			return children;
		}

		return null;
	};

	return _react2.default.createElement(
		StyledAvatar,
		props,
		renderLabel()
	);
};

Avatar.defaultProps = {
	user: '',
	img: '',
	color: '',
	id: '',
	children: null,
	onClick: null
};

Avatar.propTypes = {
	user: _propTypes2.default.string,
	img: _propTypes2.default.string,
	color: _propTypes2.default.string,
	children: _propTypes2.default.element,
	id: _propTypes2.default.string,
	onClick: _propTypes2.default.func
};

exports.Avatar = Avatar;